module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-LightItalic.08acae9c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-LightItalic.woff2
// module id = 521
// module chunks = 0